import ActionMenu from 'features/ActionMenu';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState, Fragment } from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import removeHTML from 'shared/utils/removeHTML';
import { CircularProgress } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import locationHelper from 'shared/utils/locationHelper';
import { PROVIDER_TD_BANK } from '../Shared/constants';
import withRouter from 'shared/utils/WithRouter';
import isLocalStorageAvailable from 'shared/utils/isLocalStorageAvailable';

export const styles = {
	applicationEntryButton: {
		margin: '20px',
	},
	buttonDiv: {
		textAlign: 'center',
	},
	flex: {
		flex: 1,
		height: 64,
		padding: '8px',
	},
	headline: {
		textAlign: 'center',
	},
	subheading: {
		textAlign: 'center',
	},
	body1: {
		textAlign: 'center',
	},
	securityText: {
		textAlign: 'center',
		opacity: '0.7',
	},
	logo: {
		height: '100%',
		textAlign: 'center',
	},
	logoImg: {
		objectFit: 'contain',
		height: '100%',
		width: '100%',
	},
	message: {
		padding: '15px 0',
	},
	paper: {
		width: '95%',
		maxWidth: '800px',
		height: 'auto',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '8px',
	},
	paperDiv: {
		padding: '25px',
		marginBottom: '15px',
	},
	progress: {
		left: '45%',
		position: 'absolute',
		top: '40%',
	},
	toolbar: {
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		position: 'sticky',
		top: '0',
		backgroundColor: '#FFFFFF',
		marginBottom: '8px',
		zIndex: '2',
		fallbacks: {
			position: '-webkit-sticky',
		},
	},
	storeName: {
		textAlign: 'center',
	},
	welcomeCheckbox: {
		transform: 'scale(2)',
		marginRight: '15px',
		marginLeft: '15px',
	},
	acknowledgementText: {
		textAlign: 'left',
		display: 'inline-flex',
		alignItems: 'baseline',
	},
	additionalProviderReviewText: {
		textAlign: 'left',
		display: 'inline-flex',
		alignItems: 'baseline',
	},
};

function Welcome(props) {
	const [acknowledgementChecked, setAcknowledgementChecked] = useState(false);
	const [additionalProviderReviewChecked, setAdditionalProviderReviewChecked] = useState(false);
	const navigate = useNavigate();
	const {
		brandInfo,
		classes,
		settings,
		salespersonId,
		custId,
		destroyAllForms,
		destroyAllStatuses,
		destroyCustomerIdAndResultCode,
		getBrandInfo,
		setCustomerId,
		setReturnedFromThirdPartySite,
		fetchSettings,
		destroyApplicationFormData,
		setAppIndividual,
		setAppJoint,
		providerId,
		storeName,
		defaultProvider,
		setUserConsented,
		setAdditionalProviderReviewCheckboxDisplayed,
	} = props;

	useEffect(() => {
		const cfaTraceId = custId !== undefined
		?  (isLocalStorageAvailable ? localStorage.getItem('cfaTraceId')
		: 'no-local-storage') : '';
		locationHelper.location = props;
		
		getBrandInfo();
		destroyAllForms();
		destroyAllStatuses();
		destroyCustomerIdAndResultCode();
		handleFetchSettings(locationHelper, cfaTraceId);

		window.scrollTo(0, 0);
		if(custId !== undefined) {
			setReturnedFromThirdPartySite();
			setCustomerId(custId);
			navigate('/AppStatus');
		} else {
			localStorage.setItem('cfaTraceId', '');			
			destroyApplicationFormData();
		}
	}, []);

	useEffect(
		() => {
			if (providerId && providerId === PROVIDER_TD_BANK) {
				setAcknowledgementChecked(false);
			} else {
				setAcknowledgementChecked(true);
			}
		},
		[providerId],
	);

	useEffect(
		() => {
			if (defaultProvider === '' && providerId === PROVIDER_TD_BANK) {
				// using provider queue/waterfall. TD requested to show additional checkbox if going through "waterfall"
				setAdditionalProviderReviewChecked(false);
				setAdditionalProviderReviewCheckboxDisplayed(true);
			} else {
				// default provider is set, so since it's not provider queue/waterfall they will never see the checkbox
				setAdditionalProviderReviewChecked(true);
			}
		},
		[providerId],
	);

	const handleSetAppIndividual = () => {
		if (settings.generalSettings.RequireSalesPersonId === true && salespersonId === '') {
			props.router.navigate('/SalespersonRequired');
		} else {
			setAppIndividual();
			props.router.navigate('/ApplicationEntry');
		}
	};

	const handleSetAppJoint = () => {
		if (settings.generalSettings.RequireSalesPersonId === true && salespersonId === '') {
			props.router.navigate('/SalespersonRequired');
		} else {
			setAppJoint();
			props.router.navigate('/ApplicationEntry');
		}
	};

	const handleAcknowledgementCheckboxChange = () => {
		setAcknowledgementChecked(!acknowledgementChecked);
	};

	const handleAdditionalProviderReviewCheckboxChange = () => {
		setUserConsented(!additionalProviderReviewChecked);
		setAdditionalProviderReviewChecked(!additionalProviderReviewChecked);
	};

	const handleFetchSettings = (locationHelper, cfaTraceId) => {
		if (locationHelper.location !== undefined) {
			const locationId = locationHelper.location;
			fetchSettings(locationId, cfaTraceId);
		} else {
			fetchSettings(null, cfaTraceId);
		}
	};

	function headerSection() {
		let logo;
		if (providerId && providerId === PROVIDER_TD_BANK) {
			if (brandInfo.logo) {
				logo = (
					<Fragment>
						<div className={classes.flex}>
							<div className={classes.logo}>
								<img src={brandInfo.logo} alt="STORIS" className={classes.logoImg} />
							</div>
						</div>
					</Fragment>
				);
			} else {
				logo = (
					<Fragment>
						<div className={classes.storeName}>{storeName}</div>
					</Fragment>
				);
			}
		} else {
			logo = (
				<Fragment>
					<div className={classes.flex}>
						<div className={classes.logo}>
							<img src={brandInfo.logo} alt="STORIS" className={classes.logoImg} />
						</div>
					</div>
				</Fragment>
			);
		}

		return logo;
	}

	return settings != null ? (
		<div>
			<Toolbar className={classes.toolbar}>
				<ActionMenu />
			</Toolbar>
			<Paper elevation={6} className={classes.paper}>
				<div className={classes.paperDiv}>
					{headerSection()}
					<Typography type="headline" gutterBottom className={classes.headline}>
						{settings.fieldAndFooterSettings.WelcomePageSettings.WelcomeTitle}
					</Typography>
					<Typography type="subheading" component="div" className={classes.subheading}>
						<div
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML(settings.fieldAndFooterSettings.WelcomePageSettings.WelcomeText),
							}}
						/>
					</Typography>
					<Typography type="subheading" component="div" className={classes.subheading}>
						<div
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML(settings.fieldAndFooterSettings.WelcomePageSettings.WelcomeReviewWarningText),
							}}
						/>
					</Typography>
					{providerId && providerId === PROVIDER_TD_BANK ? (
						<Typography type="subheading" component="div" className={classes.acknowledgementText}>
							<input
								type="checkbox"
								checked={acknowledgementChecked}
								onChange={handleAcknowledgementCheckboxChange}
								className={classes.welcomeCheckbox}
							/>
							<span
								// eslint-disable-next-line react/no-danger
								dangerouslySetInnerHTML={{
									__html: removeHTML(settings.fieldAndFooterSettings.WelcomePageSettings.WelcomeScreenCheckboxText),
								}}
							/>
						</Typography>
					) : null}
					{defaultProvider === '' && providerId === PROVIDER_TD_BANK ? (
						<Typography type="body1" component="div">
							<div
								// eslint-disable-next-line react/no-danger
								dangerouslySetInnerHTML={{
									__html: removeHTML(
										settings.fieldAndFooterSettings.WelcomePageSettings.AdditionalProviderReviewCheckboxLabel,
									),
								}}
							/>
						</Typography>
					) : null}
					{defaultProvider === '' && providerId === PROVIDER_TD_BANK ? (
						<Typography
							type="subheading"
							component="div"
							className={classes.additionalProviderReviewText}
						>
							<input
								type="checkbox"
								checked={additionalProviderReviewChecked}
								onChange={handleAdditionalProviderReviewCheckboxChange}
								className={classes.welcomeCheckbox}
							/>
							<span
								// eslint-disable-next-line react/no-danger
								dangerouslySetInnerHTML={{
									__html: removeHTML(settings.fieldAndFooterSettings.WelcomePageSettings.AdditionalProviderReviewCheckboxText),
								}}
							/>
						</Typography>
					) : null}
					<div className={classes.buttonDiv}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => handleSetAppIndividual()}
							className={classes.applicationEntryButton}
							// disabled={(acknowledgementChecked && additionalProviderReviewChecked) !== true}
							disabled={!acknowledgementChecked}
						>
							Single Applicant
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={() => handleSetAppJoint()}
							className={classes.applicationEntryButton}
							// disabled={(acknowledgementChecked && additionalProviderReviewChecked) !== true}
							disabled={!acknowledgementChecked}
						>
							Joint Applicant
						</Button>
					</div>
					<Typography type="body1" component="div" className={classes.securityText}>
						<div
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML(settings.fieldAndFooterSettings.WelcomePageSettings.WelcomeEncryptionNotificationText),
							}}
						/>
					</Typography>
				</div>
			</Paper>
		</div>
	) : (
		<CircularProgress className={classes.progress} size={100} thickness={3} />
	);
}

Welcome.propTypes = {
	brandInfo: PropTypes.shape({
		logo: PropTypes.string,
	}),
	classes: PropTypes.shape({}).isRequired,
	custId: PropTypes.string,
	salespersonId: PropTypes.string,
	destroyAllForms: PropTypes.func.isRequired,
	destroyAllStatuses: PropTypes.func.isRequired,
	destroyCustomerIdAndResultCode: PropTypes.func.isRequired,
	fetchSettings: PropTypes.func.isRequired,
	getBrandInfo: PropTypes.func.isRequired,
	setCustomerId: PropTypes.func.isRequired,
	setAppIndividual: PropTypes.func.isRequired,
	setAppJoint: PropTypes.func.isRequired,
	setReturnedFromThirdPartySite: PropTypes.func.isRequired,
	destroyApplicationFormData: PropTypes.func.isRequired,
	providerId: PropTypes.string,
	storeName: PropTypes.string,
	defaultProvider: PropTypes.string,
	setUserConsented: PropTypes.func.isRequired,
	setAdditionalProviderReviewCheckboxDisplayed: PropTypes.func.isRequired,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		coApp: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		comboFields: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.arrayOf(
					PropTypes.shape({ displayText: PropTypes.string, value: PropTypes.string }),
				),
				PropTypes.number,
			]),
		),
		comboFieldsByValue: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.objectOf(
					PropTypes.shape({
						displayOrder: PropTypes.number,
						fieldName: PropTypes.string,
						displayText: PropTypes.string,
						returnValue: PropTypes.string,
						requiresEmploymentData: PropTypes.bool,
					}),
				),
				PropTypes.number,
			]),
		),
	}),
};

Welcome.defaultProps = {
	brandInfo: {
		logo: '',
		topics: [{}],
	},
	custId: undefined,
	settings: undefined,
	salespersonId: undefined,
	providerId: undefined,
	storeName: undefined,
	defaultProvider: undefined,
};

export default withRouter(withRouter(withStyles(styles, { name: 'Welcome' })(Welcome)));
